// extracted by mini-css-extract-plugin
module.exports = {"highlights":"Highlights_highlights__Q01v4","highlight":"Highlights_highlight__3FKbD","icon":"Highlights_icon__1jWz_","description":"Highlights_description__bErgc"};